import React from 'react'
import { Table_2 } from '../../../utils/Table_2'
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { AlertTriangle, Search } from 'react-feather';
import { startloadListBirthdays } from '../../../../app/store/reportes/thunks';

export const Birthdays = () => {

    const { isLoading, status_report, listServices,birthdays } = useSelector(state => state.reportes);

    const { register, control, handleSubmit, watch, reset, getValues, setValue, formState: { errors } } = useForm({ model: 'all' });
    let f = new Date(); let dia = f.getDate(); let mes = f.getMonth() + 1; if (dia < 10) dia = "0" + dia; if (mes < 10) mes = "0" + mes; let today = f.getFullYear() + "-" + mes + "-" + dia;
    const dispatch = useDispatch();


 
    const searchOrdenes = (data) => {

        let fechaI = data.fechaInicial; 
        let mesI = fechaI.substring(5, 7);  
        let diaI = fechaI.substring(8, 10); 
        let fechaFormateadaI = `${mesI}-${diaI}`;


        
        let fechaT = data.fechaFinal; 
        let mesF = fechaT.substring(5, 7);  
        let diaF = fechaT.substring(8, 10); 
        let fechaFormateadaF = `${mesF}-${diaF}`;
        dispatch(startloadListBirthdays(fechaFormateadaI,fechaFormateadaF))
    }




    const dataU = [...birthdays];
    const columnsType1 = [

        {
            header: 'NOMBRE',
            dataIndex: 'NOMBRE',
            classHeader: 'text-start',
            classRow: 'text-start',
        },
        {
            header: 'F.NACIMIENTO',
            dataIndex: 'NACIMIENTO',
            classHeader: 'text-center',
            classRow: 'text-center',
        },
        {
            header: 'CELULAR',
            dataIndex: 'CELULAR',
            classHeader: 'text-center',
            classRow: 'text-center',
        },
        {
            header: 'TELEFONO',
            dataIndex: 'TELEFONO',
            classHeader: 'text-center',
            classRow: 'text-center',
        },
        {
            header: 'EMAIL',
            dataIndex: 'EMAIL',
            classHeader: 'text-start',
            classRow: 'text-start',
        },
    ];


    return (
        <div className="card">
            <div className="card-header border-bottom">
                <h4 className="fw-bold text-black">Cumpleañeros</h4>
            </div>
            <div className="card-body">


                <form className='row' onSubmit={handleSubmit(searchOrdenes)} >
                    <div className="col-6 col-sm-6 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
                        <label className="form-label">Fecha de Inicio:</label>
                        <input type="date" className="form-control" {...register("fechaInicial", { required: 'Introduce fecha de inicio' })} />
                        {
                            errors.fechaInicial &&
                            <div className='text-left-5 mt-2'>
                                <AlertTriangle size="18" color="#dc3545" />
                                <span className='text-left-10 fw-bold text-danger'><small>{errors.fechaInicial.message}</small></span>
                            </div>
                        }
                    </div>
                    <div className="col-6 col-sm-6 col-md-2 col-lg-2 col-xl-2 col-xxl-2  ">
                        <label className="form-label">Fecha de Termino:</label>
                        <input type="date" className="form-control" defaultValue={today} {...register("fechaFinal")} />
                    </div>

                    <div className="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 col-xxl-2 mt-1">
                        <div className="mb-3 mt-4">
                            <button type="submit" className="btn btn-outline-secondary">
                                <Search size="20" /> Buscar
                            </button>
                        </div>
                    </div>
                </form>
                <hr className='my-0' />
                <h5 className='fw-bold mt-4 mb-2'>Resultados</h5>
                <Table_2 typeTable={3} columns={columnsType1} data={dataU} msg={'En espera para mostrar datos'} />


            </div>
        </div>
    )
}
